module.exports = __webpack_public_path__ + "img/pic1.2924a7d1.jpeg";